/** localStorage key both translation services persist the selected UI language to. */
export const LANGUAGE_STORAGE_KEY = 'app-language';

/**
 * Resolve the currently selected UI language.
 *
 * TranslationService (authenticated pages) and PublicTranslationService (public pages like
 * login/forgot-password) each keep their own in-memory signal, but both persist to
 * localStorage[LANGUAGE_STORAGE_KEY], so the stored value is the one both agree on.
 *
 * Use this anywhere the answer has to match the Accept-Language header sent by
 * http.interceptor.ts -- in particular when caching a server-translated response, which must
 * be keyed by the language it holds.
 *
 * @param fallback Returned when nothing is stored or localStorage is unavailable (e.g. SSR).
 */
export function getActiveLanguage(fallback = 'en'): string {
  try {
    if (typeof localStorage !== 'undefined') {
      const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
      if (stored && stored.trim()) {
        return stored.trim().toLowerCase();
      }
    }
  } catch {
    // localStorage may be unavailable (e.g. SSR) -- fall back to the caller's value.
  }
  return fallback;
}
